import { render, staticRenderFns } from "./PaykaModal.vue?vue&type=template&id=02daad0d"
import script from "./PaykaModal.vue?vue&type=script&lang=js"
export * from "./PaykaModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports